import React, { useState } from "react";
import RequestService from "../../services/request.service";

import { toast } from 'react-toastify'

import moment from 'moment'
import 'moment/locale/es'



import Pagination from "../../services/Pagination";
import { Table, Form } from 'react-bootstrap'


import ModalEditarInformacionSucursales from './ModalEditarInformacionSucursales'


import ModalEstructuraPagosEstrategias from './ModalEstructuraPagosEstrategias'


import ModalAgregarSucursal from './ModalAgregarSucursal'


const Sucursales = () =>{


        const [allSessionsCount,setCounter] = useState(0);
        const sessionsPerPage = 100
        const [currentPage, setCurrentPage] = useState(1);

        const [ text_busqueda, setTextoBusqueda ] = useState('')

        const [ cargando_, setCargando ] = useState( false )

        const skull = { results: [] }

        const [ resultados, setResultados ] = useState<any>({...skull})

        const cargarMiReporte = async(page:number)=>{
          try{
            setCargando(true)
            let skip = 0
            if(page===0) skip = 0; else skip = (page*sessionsPerPage);
            let response : any = await RequestService.getEndPoint(`sucursales/${arreglo_estatus}/busqueda?where=${text_busqueda}&skip=${skip}&limit=${sessionsPerPage}`)
            setCounter(response.data.totalCount)
            setResultados(response.data.resultados)
            setCargando(false)
          }
          catch(e:any){

            if (e.response?.status) {
              switch (e.response.status) {
                case 404:
                  toast.error("Debes escribir algo")
                  break;
                default:
                  toast.error(e.response?.data)
              }
            }
            else{
              toast.error("Problemas con la busqueda")
            }
            setCargando(false)

          }
        }


        const busqueda = async () =>{
          cargarMiReporte(currentPage===0?0:currentPage-1)
          setCurrentPage(1)
        }

        const [ arreglo_estatus, setEstatus ] = useState<any>([true])


        const todos = () =>{
          setEstatus([true])
        }
        const ninguno = () =>{
          setEstatus([false])
        }


            React.useEffect(() => {
              busqueda()
            }, []);





    const [ sucursal_seleccionada, setSucursalSeleccionada ] = useState<any>(null)
    const [ show_ModalEditarInformacionSucursales, setModalEditarInformacionSucursales ] = useState<boolean>(false)
    const handleShow_ModalEditarInformacionSucursales = (sucursal:any) => {
      setSucursalSeleccionada(sucursal)
      setModalEditarInformacionSucursales(true)
    }
    const handleClose_ModalEditarInformacionSucursales = () => {
          cargarMiReporte(currentPage===0?0:currentPage-1)
      // cargarSucursales()
      setModalEditarInformacionSucursales(false)
    }





  const [ show_ModalEstructuraPagosEstrategias, setModalEstructuraPagosEstrategias ] = useState<boolean>(false)
  const handleShow_ModalEstructuraPagosEstrategias = (sucursal:any) => {
      setSucursalSeleccionada(sucursal)
    setModalEstructuraPagosEstrategias(true)
  }
  const handleClose_ModalEstructuraPagosEstrategias = () => {
          cargarMiReporte(currentPage===0?0:currentPage-1)
    setModalEstructuraPagosEstrategias(false)
  }




  const [ show_ModalAgregarSucursal, setModalAgregarSucursal ] = useState<boolean>(false)
  const handleShow_ModalAgregarSucursal = () => {
    setModalAgregarSucursal(true)
  }
  const handleClose_ModalAgregarSucursal = () => {
          cargarMiReporte(currentPage===0?0:currentPage-1)
    setModalAgregarSucursal(false)
  }


      return (
          <>
            <div className="container-fluid">

              <div className="row justify-content-center">
                <div className="col-10 col-sm-11">

                    <h4>Sucursales</h4>
                    <hr/>



                        <div className="mb-2">
                            <label className="form-label">Búsqueda</label>
                            <div className="hstack gap-3">
                              <input className="form-control me-auto" type="text"  onKeyDown={(e)=>{if(e.keyCode === 13){ busqueda() }}} value={text_busqueda} onChange={event => setTextoBusqueda(event.target.value)} />
                              <button type="button" onClick={busqueda}  className="btn btn-secondary"><i className="fa fa-search" /></button>
                              <div className="vr"></div>
                              <button type="button" onClick={(e:any)=>{setTextoBusqueda('')}} className="btn btn-outline-danger"><i className="fa fa-trash"/></button>
                            </div>
                        </div>


                        <ul className="list-inline">
                          <li className="list-inline-item">
                            <button type="button" className="btn btn-link" onClick={handleShow_ModalAgregarSucursal}>Agregar Sucursal</button>
                          </li>
                        </ul>


                          {  (!cargando_) && (

                              <>

                                   {
                                     resultados.length > 0 && (

                                       <>


                                       <h5 className="mt-4">Resultados</h5>


                                        <Table responsive="lg">
                                          <thead>
                                            <tr>
                                              <th scope="col">Sucursal</th>
                                              <th scope="col"></th>
                                              <th scope="col"></th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {


                                              resultados.map( (sucursal:any,indice:number) =>
                                                  <tr key={indice} >
                                                    <td className="v text-left" style={{"width":400}}>
                                                        {sucursal.nombre_sucursal} {' '} {sucursal.id}
                                                    </td>
                                                    <td className="v text-left" >
                                                        <p className="nm"><small><b>{sucursal.direccion}</b></small></p>
                                                    </td>
                                                    <td className="v text-left" style={{"width":"50px"}}>
                                                        <button onClick={()=>{handleShow_ModalEditarInformacionSucursales(sucursal)}} className="btn btn-sm btn-link"><i className="fa fa-edit" /></button>
                                                    </td>
                                                    {/*<td className="v text-left" style={{"width":"50px"}}>
                                                        <button onClick={()=>{handleShow_ModalEstructuraPagosEstrategias(sucursal)}} className="btn btn-sm btn-link"><i className="fa fa-money" /></button>
                                                    </td>*/}
                                                  </tr>
                                               )
                                            }

                                          </tbody>
                                        </Table>


                                          <Pagination
                                            itemsCount={allSessionsCount}
                                            itemsPerPage={sessionsPerPage}
                                            currentPage={currentPage}
                                            setCurrentPage={setCurrentPage}
                                            cambiarPaginaEvento={cargarMiReporte}
                                            alwaysShown={false}
                                          />


                                        </>



                                       )
                                     
                                   }


                              </>

                           )}

                          {  cargando_ && (

                              <>
                                <div className="loader">
                                  <div className="loaderBar"></div>
                                </div>
                              </>


                           )}















                    
                </div>
              </div>

            </div>












  {
    show_ModalEditarInformacionSucursales && (
      <ModalEditarInformacionSucursales show={show_ModalEditarInformacionSucursales} handleClose={handleClose_ModalEditarInformacionSucursales} sucursal_seleccionada={sucursal_seleccionada} />
      )

  }



  {
    show_ModalEstructuraPagosEstrategias && (
      <ModalEstructuraPagosEstrategias show={show_ModalEstructuraPagosEstrategias} handleClose={handleClose_ModalEstructuraPagosEstrategias} sucursal_seleccionada={sucursal_seleccionada} />
      )

  }



  {
    show_ModalAgregarSucursal && (
      <ModalAgregarSucursal show={show_ModalAgregarSucursal} handleClose={handleClose_ModalAgregarSucursal}  />
      )

  }






          </>

      );
  

}

export default Sucursales
